export default "__VITE_ASSET__eeebfded__"